<template>
  <div class="shadow-lg rounded-lg bg-white relative">
    <div class="border-b p-4 relative">
      <p class="font-bold text-xl">{{ detail?.username }}</p>
      <p class="">{{ detail?.date_created }}</p>
      <p class="text-accent-color">{{ $t(`commentObjectType.${detail?.content_object?.type}`) }}</p>
      <p
        class="text-white absolute top-0 right-0 px-3 py-1 rounded-bl"
        :class="state[detail.status].color"
      >
        {{ state[detail.status]['label'][$i18n.locale] }}
      </p>
    </div>
    <div class="p-4">
      <div class="flex gap-3 min-w-0">
        <div class="shrink-0">
          <img
            v-if="thumbnailUrl"
            class="size-20 aspect-square object-cover rounded"
            :src="thumbnailUrl"
            alt=""
          />
          <div
            v-else
            class="size-20 rounded bg-gray-100 border flex items-center justify-center text-gray-400"
          >
            —
          </div>
        </div>
        <div class="flex flex-col min-w-0 flex-1">
          <p class="text-lg font-bold truncate">
            {{ detail?.content_object?.name }}
          </p>
          <p class="font-bold text-accent-color">{{ detail?.content_object?.price }} TMT</p>
        </div>
      </div>
      <p class="mt-2">
        {{ detail?.text }}
      </p>
    </div>
    <div class="border-t p-4">
      <div class="w-full">
        <SubmitBtn v-if="!isMyReplies" @click="replyToComment" class="!py-1 px-4 ml-auto">{{
          $t('action.answer')
        }}</SubmitBtn>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CommentCard',
  components: {},
  props: {
    detail: {
      type: Object,
      default: () => ({}),
    },
    isMyReplies: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      state: {
        0: {
          label: { tk: 'Täze', ru: 'Новый' },
          color: 'bg-yellow-500',
        },
        1: {
          label: { tk: 'Neşir edildi', ru: 'Опубликовано' },
          color: 'bg-green-500',
        },
        2: {
          label: { tk: 'Gadagan edildi', ru: 'Запрещено' },
          color: 'bg-red-500',
        },
      },
    };
  },
  computed: {
    thumbnailUrl() {
      const thumbnail = this.detail?.content_object?.thumbnail;

      if (this.isValidImageUrl(thumbnail)) {
        return thumbnail;
      }

      const firstAttachment = this.detail?.attachments?.find(item =>
        this.isValidImageUrl(item?.path),
      );

      return firstAttachment?.path || '';
    },
  },
  methods: {
    isValidImageUrl(url) {
      const value = String(url || '').trim();

      if (!value) return false;

      if (value.includes('/api/comments/')) return false;

      return (
        value.startsWith('http://') || value.startsWith('https://') || value.startsWith('/media/')
      );
    },

    replyToComment() {
      this.$emit('replyToComment', {
        itemId: this.detail?.content_object?.id,
        contentType: this.detail?.content_object?.type,
        objectId: this.detail?.id,
      });
    },
  },
};
</script>
<style scoped></style>
